import { useDelayedModalState } from '@pelckmans/business-components/hooks/useDelayedModalState';
import { createPortal } from 'react-dom';
import uiComponentsConfig from '../../../UIComponentsConfig';
import TutorialModal from '../_modals/TutorialModal';

const ID_TUTORIAL_MODAL = 'tutorial-modal';

type Props = {
  tutorialId: string;
};

export default function TutorialEndAdornment({ tutorialId }: Props) {
  const [tutorialModalVisible, setTutorialModalVisible] = useDelayedModalState(
    ID_TUTORIAL_MODAL,
    uiComponentsConfig.closeAnimationInMs,
  );

  return (
    <>
      <button onClick={() => setTutorialModalVisible(true)} className="dialog-info">
        <svg className="icon" role="img">
          <use xlinkHref="#icon-info" />
        </svg>
      </button>
      {tutorialModalVisible &&
        createPortal(
          <TutorialModal
            id={ID_TUTORIAL_MODAL}
            tutorialId={tutorialId}
            onClose={() => setTutorialModalVisible(false)}
          />,
          document.body,
        )}
    </>
  );
}
